module.exports = __webpack_public_path__ + "img/volume-off.c82ffc22.svg";